import { Icon } from '@iconify/react';


// Logos oficiais usando Iconify
export const MetaLogoIcon = (props: any) => <Icon icon="logos:meta-icon" {...props} />;
export const WhatsAppIcon = (props: any) => <Icon icon="ri:whatsapp-line" className="text-[#25D366]" {...props} />;
export const MessengerIcon = (props: any) => <Icon icon="logos:messenger" {...props} />;
export const GoogleAdsLogoIcon = (props: any) => <Icon icon="logos:google-ads" {...props} />;
export const FacebookIcon = (props: any) => <Icon icon="ri:facebook-fill" className="text-[#1877F2]" {...props} />;
/** Logo oficial Instagram (gradiente) — Iconify skill-icons. */
export const InstagramIcon = (props: any) => {
    const { className, ...rest } = props;
    return (
        <Icon
            icon="skill-icons:instagram"
            {...rest}
            className={['shrink-0', className].filter(Boolean).join(' ')}
        />
    );
};
export const PixIcon = (props: any) => {
    const { className, style, ...rest } = props;
    return (
        <Icon
            icon="simple-icons:pix"
            width="1em"
            height="1em"
            {...rest}
            style={style}
            className={['shrink-0', 'text-[#32BCAD]', className].filter(Boolean).join(' ')}
        />
    );
};
/** Pix oficial vazado — uso em settings (alinha aos ícones Lucide via currentColor). */
export const PixLineIcon = (props: any) => <Icon icon="ri:pix-line" {...props} />;
